module.exports = __webpack_public_path__ + "assets/img/tag-weapon-soul-4403cdb2.png";